import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "../components/Loader";
import CardSwitcher from "../components/cards/CardSwitcher";


const ProfilePage = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
  fetch(`https://app.kwbodrum.com.tr/panel/api.php?slug=${slug}`)
    .then((res) => res.json())
    .then((json) => {
      console.log("API cevabı:", json);
      if (json.error) {
        setNotFound(true);
      } else {
        setData(json);
        setNotFound(false);
      }
    })
    .catch((err) => {
      console.error("Hata:", err);
      setNotFound(true);
    });
}, [slug]);

  return (
    <div style={{ padding: 20, paddingTop: 30, background: "#f5f5f5", minHeight: "100vh" }}>
      {console.log}
      {notFound ? (
        <div style={{ textAlign: "center", marginTop: "60px", color: "#777" }}>
          <h2>❌ Profil bulunamadı</h2>
          <p>Lütfen geçerli bir bağlantı kullanın.</p>
        </div>
      ) : data ? (
        <CardSwitcher data={data} />
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default ProfilePage;
